<template>
  <div class="details">

    <div class="row">
      <div class="data-field">
        <div class="label">Name</div>
        <div class="value">
          <span>{{ promo.name }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="data-field">
        <div class="label">Description</div>
        <div class="value">
          <span>{{ promo.description || '--' }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-4 padding-R">
        <div class="data-field">
          <div class="label">Start Date</div>
          <div class="value">
            <span>{{ promo.startDate }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4 padding-L padding-R">
        <div class="data-field">
          <div class="label">Expiration Date</div>
          <div class="value">
            <span>{{ promo.expirationDate }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4 end padding-L">
        <div class="data-field">
          <div class="label">Days Valid after Redemption</div>
          <div class="value">
            <span>{{ promo.validDays }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-4 padding-R">
        <div class="data-field">
          <div class="label">Valid Only for New Users</div>
          <div class="value">
            <span>{{ promo.validNewUser }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4 padding-L end">
        <div class="data-field">
          <div class="label">Valid for Specific Services</div>
          <div class="value">
            <span>{{ promo.validServices }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-4 padding-R">
        <div class="data-field">
          <div class="label">Promo Code</div>
          <div class="value">
            <span>{{ promo.code }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4 padding-L padding-R">
        <div class="data-field">
          <div class="label">Credit Amount</div>
          <div class="value">
            <span>{{ promo.amount }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4 padding-R">
        <div class="data-field">
          <div class="label">Total Codes</div>
          <div class="value">
            <span>{{ promo.totalCodes }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-4 padding-R end">
        <div class="data-field">
          <div class="label">Codes Redeemed</div>
          <div class="value">
            <span>{{ promo.redeemedCodes }}</span>
          </div>
        </div>
      </div>
      <div class="column small-4  padding-L end">
        <div class="data-field">
          <div class="label">Codes Left</div>
          <div class="value">
            <span>{{ promo.totalCodes - promo.redeemedCodes}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import promoList from './PromoList'
import ApiPromo from '@/modules/api/promo'

export default {
  name: 'promo-view-details',
  components: {},
  data () {
    return {
    }
  },
  computed: {
    promo () { return this.$store.state.promo.view.details }
  },
  methods: {
    init () {
    }
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.details{
  margin-top: 20px;
  padding: 0 30px;
}

.data-field{
  font-weight: 600;
  margin-bottom: 30px;
  .label{
    color: #5495c3;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 120%;
  }
  .value{
    font-size: 17px;
    color: #555;

    &.service-type{ text-transform: capitalize; }
    &.credit-card{ font-size: 16px; }
    .fa-star{
      color: #f1d724;
      margin-right: 5px;
    }
    .payment-trigger{
      font-size:11px;
      vertical-align: 3px;
      text-decoration: underline;
      margin-left: 2px;
      cursor: pointer;
    }
    a{
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }

@media only screen and (max-width: 430px) {
  .details {
    margin-top: 125px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/PromoViewDetails.vue